export default __webpack_public_path__ + "static/media/prospect4.96328249.jpg";